var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("instance-img", {
        ref: "instanceImg",
        attrs: { data: _vm.data },
        on: { showData: _vm.onShowData, showDetail: _vm.onShowDetail },
      }),
      _vm.detail
        ? _c(
            "div",
            { staticClass: "c7n-saga-img-detail" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.title,
                      expression: "title",
                    },
                  ],
                  staticClass: "c7n-saga-task-detail",
                },
                [
                  _c("div", { staticClass: "c7n-saga-task-detail-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _c("div", { staticClass: "c7n-saga-task-detail-content" }, [
                    _c("div", { staticClass: "c7n-saga-detail-json" }, [
                      _c("pre", [_vm._v(_vm._s(_vm.detail))]),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.title,
                      expression: "!title",
                    },
                  ],
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "基本信息", name: "1" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "140px",
                            "label-position": "left",
                          },
                        },
                        [
                          _c("el-form-item", { attrs: { label: "序列" } }, [
                            _vm._v(" " + _vm._s(_vm.detail.seq) + " "),
                          ]),
                          _c("el-form-item", { attrs: { label: "任务编码" } }, [
                            _vm._v(" " + _vm._s(_vm.detail.taskCode) + " "),
                          ]),
                          _c("el-form-item", { attrs: { label: "saga编码" } }, [
                            _vm._v(" " + _vm._s(_vm.detail.sagaCode) + " "),
                          ]),
                          _c("el-form-item", { attrs: { label: "任务描述" } }, [
                            _vm._v(" " + _vm._s(_vm.detail.description) + " "),
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("table.statusText") } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      _vm.detail.status === "RUNNING"
                                        ? "success"
                                        : _vm.detail.status === "FAILED"
                                        ? "danger"
                                        : _vm.detail.status === "COMPLETED"
                                        ? "info"
                                        : _vm.detail.status === "NON_CONSUMER"
                                        ? "success"
                                        : _vm.detail.status ===
                                          "WAIT_TO_BE_PULLED"
                                        ? "success"
                                        : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.typeList.bjGet(_vm.detail.status)
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm.detail.status === "FAILED"
                                ? [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.wait,
                                            expression: "!wait",
                                          },
                                        ],
                                        staticClass: "ml0 xs",
                                        attrs: {
                                          type: "info",
                                          icon: "el-icon-refresh",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.retry(_vm.detail.id)
                                          },
                                        },
                                      },
                                      [_vm._v("重 试")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.wait,
                                            expression: "wait",
                                          },
                                        ],
                                        staticClass: "ml0 xs",
                                        attrs: {
                                          type: "danger",
                                          icon: "el-icon-warning",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.faild(_vm.detail.id)
                                          },
                                        },
                                      },
                                      [_vm._v("强制失败")]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "所属微服务" } },
                            [_vm._v(" " + _vm._s(_vm.detail.service) + " ")]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "运行的微服务实例" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.instanceLock) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "并发限制模式" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.detail.concurrentLimitPolicy) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "最大并发数" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.detail.concurrentLimitNum) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "最大重试次数" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.maxRetryCount) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "已重试次数" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.retriedCount) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "计划执行时间" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.plannedStartTime) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "实际开始时间" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.actualStartTime) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "实际完成时间" } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.detail.actualEndTime) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "参数 & 异常", name: "2" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "40px",
                            "label-position": "left",
                          },
                        },
                        [
                          _c("el-form-item", { attrs: { label: "入参" } }),
                          _c("json-viewer", {
                            attrs: {
                              value: _vm.detail.input,
                              "expand-depth": 9,
                            },
                          }),
                          _c("el-form-item", { attrs: { label: "出参" } }),
                          _c("json-viewer", {
                            attrs: {
                              value: _vm.detail.output,
                              "expand-depth": 9,
                            },
                          }),
                          _vm.detail.exceptionMessage
                            ? [
                                _c("el-form-item", {
                                  attrs: { label: "异常" },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "c7n-saga-detail-json" },
                                  [
                                    _c("pre", [
                                      _vm._v(
                                        _vm._s(_vm.detail.exceptionMessage)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }